import React from 'react';
import { useTranslation } from 'react-i18next';
import { ClipboardList } from 'lucide-react';
import * as Tooltip from '@radix-ui/react-tooltip';
import Button from '../../../../components/ui/Button';

/** The small icon button that opens the pre-flight checklist. */
export const ChecklistButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <Button variant="outline" size="xs" onClick={onClick} aria-label={t('payroll.wps.viewChecklist', 'View pre-flight checklist')}>
            <ClipboardList size={16} />
          </Button>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content className="bg-card border border-border rounded-md px-2 py-1 shadow-md text-xs z-50" sideOffset={5}>
            {t('payroll.wps.viewChecklist', 'View pre-flight checklist')}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
